import api from './api';

/**
 * The institution directory: identity, facilities addresses, and the policy
 * text each campus shows its members. Reading is open to any signed-in member;
 * writing is the admin editor's, and the server refuses everyone else.
 */
export const institutionService = {
    async list() {
        const response = await api.get('/institutions');
        return response.data;
    },

    /**
     * Write one institution's configuration. `body` carries `facilitiesEmails`
     * and/or a partial `policy`; a policy field sent as null returns to its
     * default.
     */
    async update(key, body) {
        const response = await api.put(`/institutions/${key}`, body);
        return response.data;
    },
};

export default institutionService;
